import { Component } from '@angular/core';
import { DocumentViewer, DocumentViewerOptions } from '@ionic-native/document-viewer/ngx';
// import { InAppBrowser, InAppBrowserOptions } from 'in-app-browser';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Master, Project, Api } from '@providers/index';

@Component({
  selector: 'page-detail-budget',
  templateUrl: 'page.html'
})
export class DetailBudgetPage {

  content:any;
  loading:any;

  file_url : any;

  project_id = 0;
  
  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    public  loadingCtrl: LoadingController,
    public  api        : Api,
    public  masterApi  : Master,
    public  projectApi : Project,
    private document   : DocumentViewer,
    // private iab        : InAppBrowser
  ) {

    this.file_url = this.api.url+'/client/uploads/';
    this.project_id = navParams.get('project_id');
    
  }

  ionViewDidEnter() {
    this.openBrowser();
  }

  viewDocument(){
    const options: DocumentViewerOptions = {
      title: 'My PDF'
    }
    this.document.viewDocument('http://202.147.194.34/api_trial/client/uploads/bulletin.pdf','application/pdf', options);
  }

  openBrowser(){
    // const options: InAppBrowserOptions ={
    //   closebuttoncaption: 'Close'

    // }
    // const browser = this.iab.create(this.file_url+'project_budget.html', '_self', options);
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getContent();
  }
 
  getContent(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params:any = {
      project_id : this.project_id
    };
    this.projectApi.get(params).subscribe((resp:any) => {
      this.content = resp.data[0].detail_budget;
      console.log("content => ", this.content);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
    
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/detail_budget/page.ts